import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { loadConfig } from "../helpers/config";
import LoadingSpinner from "../components/LoadingSpinner";
import { useNavigate } from "react-router-dom";

export default function QrDesktop() {
  const [qrValue, setQrValue] = useState(null);
  const [waiting, setWaiting] = useState(false);
  const [apiUrl, setApiUrl] = useState("");
  const [loadingConfig, setLoadingConfig] = useState(true);
  const [error, setError] = useState("");
  const intervalRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchConfig() {
      const config = await loadConfig();
      setApiUrl(config.APIURL);
      setLoadingConfig(false);
    }
    fetchConfig();
  }, []);

  // Start session automatically on mount
  useEffect(() => {
    async function startSession() {
      setQrValue(null);
      setWaiting(true);
    }
    if (!waiting && apiUrl && !loadingConfig) {
      startSession();
    }
  }, [apiUrl, waiting, loadingConfig]);

  useEffect(() => {
    if (waiting && apiUrl) {
      intervalRef.current = setInterval(async () => {
        try {
          const accessToken = localStorage.getItem("accessToken");
          const res = await axios.get(`${apiUrl}/qr-session`, {
            headers: { accessToken }
          });
          if (res.data.value) {
            setQrValue(res.data.value);
            setWaiting(false);
            clearInterval(intervalRef.current);
            // Treat all QR values as serial numbers
            try {
              const toolRes = await axios.get(`${apiUrl}/tool/by-serial/${encodeURIComponent(res.data.value)}`, {
                headers: { accessToken }
              });
              if (toolRes.data.id) {
                navigate(`/tool/${toolRes.data.id}`);
              } else {
                setError(`Kein Gerät mit der Seriennummer '${res.data.value}' gefunden.`);
                setQrValue(null);
              }
            } catch (err) {
              setError(`Ungültige oder nicht gefundene Seriennummer: '${res.data.value}'.`);
              setQrValue(null);
            }
          }
        } catch (err) {
          setError("Fehler beim Empfangen des QR-Codes oder der Seriennummer.");
          setQrValue(null);
        }
      }, 1500);
      return () => clearInterval(intervalRef.current);
    }
  }, [waiting, apiUrl, navigate, error]);

  if (loadingConfig) {
    return <LoadingSpinner text="Lade Konfiguration..." />;
  }

  // Ensure qrValue is not shown if error is present
  const showQrValue = qrValue && !error;
  return (
    <div className="container">
      <h2>QR-Code Empfang (Desktop)</h2>
      {waiting && (
        <div style={{ marginTop: 20 }}>
          <div>Warte auf QR-Code von Smartphone...</div>
        </div>
      )}
      {showQrValue && (
        <div style={{ marginTop: 20 }}>
          <div>Empfangener QR-Code:</div>
          <div style={{ fontWeight: "bold", fontSize: "1.5rem" }}>{qrValue}</div>
        </div>
      )}
      {error && (
        <div style={{ marginTop: 20, color: "red" }}>{error}</div>
      )}
    </div>
  );
}
